module.exports = __webpack_public_path__ + "static/img/audio.326a2956.svg";